import { z } from "zod";
const STATIC_AGENT_SECTION_LABELS = {
  agent_name: "Name",
  agent_role_and_personality: "Role and personality",
  caller_context: "Caller context",
  conversation_flow: "Conversation flow",
  behavior_and_guardrails: "General behavior and guardrails",
  outreach_instructions: "Outreach instructions"
};
const agentInstructionCheckSchema = z.object({
  status: z.enum(["pass", "fail"]),
  explanation: z.string().describe(
    "A concise explanation (1-3 sentences) of the pass/fail assessment."
  )
});
const agentInstructionChecksLlmOutputSchema = z.object({
  identity: z.object({
    name_and_role_clear: agentInstructionCheckSchema,
    tone_and_personality_clear: agentInstructionCheckSchema
  }),
  caller_context: z.object({
    caller_persona_defined: agentInstructionCheckSchema,
    consistent_with_conversation_flow: agentInstructionCheckSchema
  }),
  conversation_flow: z.object({
    opening_clear: agentInstructionCheckSchema,
    steps_well_sequenced: agentInstructionCheckSchema,
    ending_paths_defined: agentInstructionCheckSchema,
    instructions_consistent: agentInstructionCheckSchema,
    tool_usage_clear: agentInstructionCheckSchema
  }),
  behavior_and_guardrails: z.object({
    boundaries_defined: agentInstructionCheckSchema,
    unexpected_scenarios_handled: agentInstructionCheckSchema,
    guardrails_consistent: agentInstructionCheckSchema,
    instructions_not_duplicated: agentInstructionCheckSchema
  })
});
const agentInstructionSectionCandidateDraftSchema = z.object({
  agent_name: z.string(),
  agent_role_and_personality: z.string(),
  caller_context: z.string(),
  conversation_flow: z.string(),
  behavior_and_guardrails: z.string()
}).partial();
const getAgentInstructionChecksToolOutputSchema = z.object({
  candidate_draft: agentInstructionSectionCandidateDraftSchema.nullable(),
  checks: agentInstructionChecksLlmOutputSchema
});
const AGENT_INSTRUCTION_SECTION_CHECK_LABELS = {
  identity: {
    name_and_role_clear: "Name and role are clear",
    tone_and_personality_clear: "Tone and personality are clear"
  },
  caller_context: {
    caller_persona_defined: "Caller persona is clearly defined",
    consistent_with_conversation_flow: "Consistent with conversation flow"
  },
  conversation_flow: {
    opening_clear: "Opening is clear",
    steps_well_sequenced: "Steps are well sequenced",
    ending_paths_defined: "Ending paths are defined",
    instructions_consistent: "Instructions are consistent",
    tool_usage_clear: "Tool usage is clear"
  },
  behavior_and_guardrails: {
    boundaries_defined: "Boundaries are defined",
    unexpected_scenarios_handled: "Unexpected scenarios are handled",
    guardrails_consistent: "Guardrails are consistent",
    instructions_not_duplicated: "Instructions are not duplicated"
  }
};
export {
  AGENT_INSTRUCTION_SECTION_CHECK_LABELS,
  STATIC_AGENT_SECTION_LABELS,
  agentInstructionChecksLlmOutputSchema,
  agentInstructionSectionCandidateDraftSchema
};
//# sourceMappingURL=voiceAgentConfigurationTools.js.map
